import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import tableRequest from "../../models/tableRequest";
import ScanQRService from "../../services/ScanQRService";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
export default class Damage extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.ScanQRService = new ScanQRService();
    this.brandTemplate = this.brandTemplate.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onPage = this.onPage.bind(this);
    this.state = {
      rows: 10,
      first: 0,
      QRData: "",
      SeqNo: "",
      damage: [],
      TestPerformed: "",
      UniqueCode: "",
      SupplierCode: "",
      BarCode: "",
      Weaving: "",
      IsActive: true,
      ProductImg: "",
      IsDamaged: true,
      ProductCode: "",
      Colour: "",
      Embroidery: "",
      UserName: "",
    };
  }

  formatCreatedDate = (rowData) => {
    if (!rowData.CreatedDate) return "";

    const date = new Date(rowData.CreatedDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  componentDidMount() {
    this.GetProducts();
  }

  onPage(event) {
    this.setState({
      loading: true,
    });
    this.getLazyLoadingValues(event);
    //imitate delay of a backend call
    setTimeout(() => {
      this.GetProducts();
    }, 500);
  }

  getLazyLoadingValues(event) {
    this.setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows,
    }));
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.PageNo = Math.floor(event.first / event.rows) + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = this.tblResponse.SearchValue;
    // EPCHID DESC is always the primary sort (set in GetProducts)
    // This sets the secondary sort based on user interaction
    this.tblResponse.SortColumn = event.sortField ? event.sortField : "EPCHID";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.UserId = sessionStorage.getItem("UserId");
    this.tblResponse.UserType = sessionStorage.getItem("userType");
  }

  // Get Products list
  GetProducts() {
    this.ScanQRService.GetEPCHData(this.tblResponse).then((data) => {
      const resdata = data.data;
      // this.setState({ updateLoader: true });
      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData.length > 0
      ) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRecords,
          first: this.tblResponse.First - 1,
          damage: this.datasource.slice(),
          loading: false,
        });
      } else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          epchData: null,
          loading: false,
        });
      }
    });
  }

  // edit form
  actionTemplate(rowData, column) {
    const editMode = (e) => {
      const formData = {
        SequenceNo: Number(rowData.SeqNo), // ensure numeric
        ProductCode: rowData.ProductCode,
        ProductImg: rowData.ProductImg,
        Colour: rowData.Colour,
        Weaving: rowData.Weaving,
        Embroidery: rowData.Embroidery,
        TestPerformed: rowData.TestPerformed,
        IsActive: true,
        IsDamaged: true, // boolean will be converted to 1 in backend
      };

      this.ScanQRService.Damage(formData).then((data) => {
        const resdata = data.data;

        // Handle different messages correctly
        if (resdata.ResponseMessage === "Damaged successfully") {
          toast.success(resdata.ResponseMessage);
          this.GetProducts();
        } else if (resdata.ResponseMessage === "Already Damaged") {
          toast.warning(resdata.ResponseMessage);
        } else if (resdata.ResponseMessage === "Record not found") {
          toast.error(resdata.ResponseMessage);
        } else {
          toast.error("Something went wrong");
        }
      });
    };

    const submit = () => {
      confirmAlert({
        title: "Confirmation",
        message: "Are you sure you want to damage.",
        buttons: [
          {
            label: "Yes",
            onClick: () => editMode(),
          },
          {
            label: "No",
          },
        ],
      });
    };

    return (
      <span>
        <Button
          type="button"
          label="Damage"
          onClick={submit}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
        {/* <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button> */}
      </span>
    );
  }

  // search filter
  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;

    this.GetProducts();
  }

  // on sort table
  onSort(event) {
    const sortField = event.sortField;
    const sortOrder = event.sortOrder === 1 ? "ASC" : "DESC";

    this.tblResponse.SortColumn = sortField || "CreatedDt";
    this.tblResponse.SortOrder = sortOrder;

    this.GetProducts();
  }

  // use for image
  brandTemplate(rowData, column) {
    var src = rowData.ProductImg;
    return <img src={src} width="30" />;
  }

  render() {
    const items = [{ label: "Masters" }, { label: "Damage" }];
    const home = { icon: "pi pi-home", url: "/dashboard" };
    return (
      <>
        <ToastContainer />
        <Card className="mt5">
          <div className="row ">
            <div className="col-md-6 heading">
              <h3>Damage</h3>
            </div>
            <div className="col-md-6 custom-breadcrumb">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            first={this.state.first}
            rows={this.state.rows}
            responsive={true}
            style={{ width: "100%" }}
            scrollable
            value={this.state.damage}
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rowsPerPageOptions={[10, 100, 200, this.state.totalRecords]}
            totalRecords={this.state.totalRecords}
            tableStyle={{ minWidth: "50rem" }}
            sortField="EPCHID"
            sortOrder={-1}
            lazy={true}
            onSort={this.onSort}
            className="p-datatable-responsive"
            onPage={this.onPage}
          >
            <Column field="SeqNo" header="Sequence No" sortable={true} />
            <Column field="UniqueCode" header="Unique Code" sortable={true} />
            <Column
              field="SupplierCode"
              header="SupplierCode"
              sortable={true}
            />
            <Column field="BarCode" header="Bar Code" sortable={true} />
            <Column field="ProductCode" header="Product" sortable={true} />

            {/* <Column field="productCd" header="Product Code" sortable={true} />
                    <Column field="prodSpecification" header="Product Specification" sortable={true} /> */}
            <Column field="Colour" header="Colour" />
            <Column field="Weaving" header="Weaving" />
            <Column field="Embroidery" header="Embroidery" />

            <Column field="TestPerformed" header="Test Performed" />
            <Column field="UserName" header="Mapping User" />
            <Column
              field="CreatedDate"
              header="Created Date"
              sortable={true}
              body={this.formatCreatedDate}
            />

            <Column
              field="ProductImg"
              // style={{ width: "100px" }}
              header="Product Image"
              body={this.brandTemplate}
            />
            {/* <Column body={this.activeTemplate} header="Status" /> */}
            <Column body={this.actionTemplate} header="Action" />
          </DataTable>
        </Card>
      </>
    );
  }
}
